import { render, staticRenderFns } from "./submit-failure.vue?vue&type=template&id=61560a62&scoped=true"
import script from "./submit-failure.vue?vue&type=script&lang=js"
export * from "./submit-failure.vue?vue&type=script&lang=js"
import style0 from "./submit-failure.vue?vue&type=style&index=0&id=61560a62&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61560a62",
  null
  
)

export default component.exports